import { render, staticRenderFns } from "./QuizCatalogConfigurator.vue?vue&type=template&id=34b14d82&"
import script from "./QuizCatalogConfigurator.vue?vue&type=script&lang=js&"
export * from "./QuizCatalogConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports